// src/utils/auth.js

const SESSION_OWNER_KEY = 'session_owner';

// Get the auth token from localStorage
export function getToken() {
  return localStorage.getItem('token');
}

// Get logged-in user data from localStorage (parsed as JSON)
export function getLoggedInUser() {
  try {
    const user = localStorage.getItem('user');
    if (!user || user === 'undefined' || user === 'null') {
      return null;
    }
    return JSON.parse(user);
  } catch {
    localStorage.removeItem('user');
    return null;
  }
}

// Save user data and token to localStorage after login
export function setLoginSession(token, user) {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem(SESSION_OWNER_KEY, 'user');
}

// Clear login session (logout)
export function logoutUser() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem(SESSION_OWNER_KEY);
}

// Check if user is logged in (returns boolean)
export function isLoggedIn() {
  return !!getToken();
}

export function getSessionOwner() {
  return localStorage.getItem(SESSION_OWNER_KEY);
}
